exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*!\n * Copyright (c) 2017 DV Bern AG, Switzerland\n *\n * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich\n * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt\n * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in\n * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur\n * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.\n *\n */", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/app/versicherungsbeitraege/component/versicherungsbeitragSchadenView/versicherungsbeitragSchadenView.scss
// module id = 7ibs
// module chunks = 0